import {
  changeAvatarSuccess,
} from 'actions/fate/changeAvatar';

import MyselfService from 'services/MyselfService';
import { MYSELF_CHANGED } from 'actiontypes/myself';
import { IMyselfService } from 'types/myself';
import { Dispatch } from 'redux';
import { IQuality } from 'types/qualities';

export default setAvatarImage(new MyselfService());

export function setAvatarImage(service: IMyselfService) {
  return ({ avatarImage }: { avatarImage: string }) => async (dispatch: Dispatch) => {
    try {
      const { data } = await service.setAvatarImage({ avatarImage });
      if (data.isSuccess) {
        dispatch(changeAvatarSuccess({ avatarImage }));
        dispatch(setAvatarImageSuccess(data));
      }
      return data;
    } catch (error) {
      console.error(error);
      // dispatch(setAvatarImageError(data));
    }
  };
}

export const setAvatarImageSuccess = ({ possessionsChanged }: { possessionsChanged: IQuality[] }) => ({
  type: MYSELF_CHANGED,
  payload: possessionsChanged.map(p => ({ possession: p })),
});